import React from 'react';
import { Col, Form, Switch } from 'antd';
import { I18n } from '@aws-amplify/core';
import { CustomItemSwitch } from './styles';

const { useFormInstance, useWatch } = Form;

export const RequireInjury: React.FC = () => {
	const form = useFormInstance();
	const injury = useWatch(['step_key', 'has_injury'], form);
	return (
		<Col xs={24}>
			<CustomItemSwitch
				name={['step_key', 'has_injury']}
				wrapperCol={{
					xs: 12,
					lg: 5,
					xxl: 3
				}}
				label={I18n.get('Indicate possible injuries/aggravations')}
			>
				<Switch checked={injury} />
			</CustomItemSwitch>
		</Col>
	);
};
